/**
 * Handle lazy loading select images after document load is
 * complete (singleton).
 */
define(['c21', 'jquery'], function (c21, $) {
   "use strict";

   function loadImages(_jImages) {
      setTimeout(function () {
         var jImages = (_jImages && _jImages.jquery) ? _jImages : $("img.lazyLoad");
         jImages.each(function () {
            var jImg = $(this),
               img = new Image(),
               strRefSrc = jImg.attr('ref'),
               strNewSrc = jImg.attr('rel');

            img.onload = function () {
               jImg.attr('src', strNewSrc);
            };

            img.onerror = function () {
               jImg.attr('src', strRefSrc);
            };

            img.src = strNewSrc;
         });
      }, 100);
   }

   $(document).ready(loadImages);

   return {
      load: loadImages,
      loadIn: function (jContainer) {
         var jImages = jContainer.find("img.lazyLoad");
         loadImages(jImages);
      }
   };
});
